import {
  ButtonBackIcon,
  CloseButtonIcon,
  UploadNewAvatarUser,
} from "./IconsStyles.styled";

export const ButtonBackPageIcon = () => {
  return (
    <>
      <ButtonBackIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#fff"
          d="M22.161 3.984c-0.155-0.155-0.339-0.278-0.541-0.362s-0.42-0.127-0.639-0.127-0.436 0.043-0.639 0.127c-0.203 0.084-0.386 0.207-0.541 0.362l-11.080 11.080c-0.124 0.123-0.222 0.27-0.289 0.431s-0.101 0.334-0.101 0.509c0 0.175 0.034 0.348 0.101 0.509s0.165 0.308 0.289 0.431l11.080 11.080c0.653 0.653 1.707 0.653 2.36 0s0.653-1.707 0-2.36l-9.653-9.667 9.667-9.667c0.64-0.64 0.64-1.707-0.013-2.347z"
        ></path>
      </ButtonBackIcon>
    </>
  );
};

export const UploadNewAvatar = () => {
  return (
    <>
      <UploadNewAvatarUser
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#fff"
          d="M13.334 21.333h5.333c0.733 0 1.333-0.6 1.333-1.333v-6.667h2.12c1.187 0 1.787-1.44 0.947-2.28l-6.12-6.12c-0.123-0.124-0.27-0.222-0.431-0.289s-0.334-0.101-0.509-0.101c-0.175 0-0.348 0.034-0.509 0.101s-0.308 0.165-0.431 0.289l-6.12 6.12c-0.84 0.84-0.253 2.28 0.933 2.28h2.12v6.667c0 0.733 0.6 1.333 1.333 1.333zM8.001 24h16c0.733 0 1.333 0.6 1.333 1.333s-0.6 1.333-1.333 1.333h-16c-0.733 0-1.333-0.6-1.333-1.333s0.6-1.333 1.333-1.333z"
        ></path>
      </UploadNewAvatarUser>
    </>
  );
};

export const CloseIconModelWindow = () => {
  return (
    <>
      <CloseButtonIcon viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="#fff"
          d="M16 17.867l-6.533 6.533c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367c-0.244-0.244-0.367-0.556-0.367-0.933s0.122-0.689 0.367-0.933l6.533-6.533-6.533-6.533c-0.244-0.244-0.367-0.556-0.367-0.933s0.122-0.689 0.367-0.933c0.244-0.244 0.556-0.367 0.933-0.367s0.689 0.122 0.933 0.367l6.533 6.533 6.533-6.533c0.244-0.244 0.556-0.367 0.933-0.367s0.689 0.122 0.933 0.367c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933l-6.533 6.533 6.533 6.533c0.244 0.244 0.367 0.556 0.367 0.933s-0.122 0.689-0.367 0.933c-0.244 0.244-0.556 0.367-0.933 0.367s-0.689-0.122-0.933-0.367l-6.533-6.533z"
        ></path>
      </CloseButtonIcon>
    </>
  );
};
